module.exports = __webpack_public_path__ + "img/card_240450750.8d743223.jpg";